import TpWidgetMicro from "@components/organisms/common/TpWidgetMicro";
import AdaptiveCriticalImage from "@components/atoms/AdaptiveCriticalImage";
import {
  colors,
  viewport,
  lineHeight,
  font,
} from "@styles/cssinjs/helpers/variables";
import Link from "next/link";

type HeaderPillProps = {
  data: any; // Replace 'any' with a specific type if possible
};

const HeaderPill = ({ data }: HeaderPillProps) => {
  return (
    <Link href="/guides" className="header-pill bg-dull-grey" prefetch={false}>
      <span className="text-xs ff-inter">Setmore guide</span>
      <style global jsx>{`
        .header-pill {
          display: inline-flex;
          gap: 4px;
          padding: 2px 12px;
          border-radius: 16px;
          border: none;
          text-transform: uppercase;
        }
        .header-pill span {
          color: ${colors.primitive.grey[300]};
          line-height: ${lineHeight[5]};
          font-size: ${font.size.sm[1]};
          font-weight: ${font.weight.semiBold};
          letter-spacing: 1px;
        }
      `}</style>
    </Link>
  );
};

type HeroProps = {
  data: any; // Replace 'any' with a specific type if possible
  isNewDesign: boolean;
};

const Hero = ({ data, isNewDesign }: HeroProps) => {
  const ctaAttrs: { [key: string]: string } = {};
  const appMode = process.env.APP_MODE;
  const signupLink = data?.cta?.href?.[appMode] || data?.cta?.href;
  if (data.hasOwnProperty("cta")) {
    if (data.cta.hasOwnProperty("isExternal")) {
      ctaAttrs.target = "_blank";
      ctaAttrs.rel = "noopener noreferrer";
    }
  }
  return (
    <section
      className={`container grid--default hero--default lg:pb-10 md:pb-10 has-align-top`}
    >
      <article className={`lg:maxw-lg text-left`}>
        {isNewDesign === true && <HeaderPill data={data} />}
        <h1 className="text-xl lg:pt-5">{data.title}</h1>
        {Array.isArray(data.desc) &&
          data.hasOwnProperty("desc") &&
          data.desc.map((item: string, index: number) => {
            return (
              <p
                className="lg:maxw-md lg:mt-2 lg:mb-2"
                key={index}
                dangerouslySetInnerHTML={{ __html: item }}
              />
            );
          })}
        {data.hasOwnProperty("cta") && (
          <div className="lg:mt-5 md:mt-3">
            <a
              href={signupLink}
              className={`btn-primary md:w-100 ${
                isNewDesign === true ? "lg:px-4" : ""
              }`}
              id={data.cta.id}
              {...ctaAttrs}
            >
              <span>{data.cta.text}</span>
            </a>
          </div>
        )}
        {data.hasOwnProperty("hasTpWidget") && (
          <>
            <TpWidgetMicro
              className={`lg:mt-5 md:pt-2 ${
                isNewDesign === true ? "md:mt-2" : "md:mt-3"
              } ${data.hasOwnProperty("cta") ? "" : "md:ml-0"}`}
            />
          </>
        )}
      </article>{" "}
      <figure className="md:mt-5 lg:maxw-lg">
        <picture>
          {isNewDesign === true ? (
            <AdaptiveCriticalImage
              src={data.img.src}
              alt={data.img.alt}
              mobile={data.img.prefixes.mobile}
              tablet={data.img.prefixes.tablet}
              dpi={data.img.prefixes.dpi}
              dimensions={data.img.dimensions}
              className="img-fit"
            />
          ) : (
            <AdaptiveCriticalImage
              src={data.img.src}
              alt={data.img.alt}
              mobile={data.img.prefixes.mobile}
              dpi={data.img.prefixes.dpi}
              dimensions={data.img.dimensions}
              className="img-fit"
            />
          )}
        </picture>
      </figure>
      <style jsx>
        {`
          @media (min-width: ${viewport.tablet.sm}) {
            .hero--default {
              margin-top: 88px;
              padding-top: 72px;
            }
            .hero--default article {
              padding-right: 52px;
            }
            .hero--default article .text-xl {
              margin-bottom: 24px;
            }
          }
          ${isNewDesign
            ? `
          .hero--default {
            position: relative;
            padding-bottom: 0px !important;
          }
          .hero--default article {
             padding-right: 0px !important;
          }
          @media (min-width: ${viewport.desktop.sm}) {
            .trustpilot-widget-micro {
              position: absolute;
              bottom: 52px;
            }
          }
          @media (max-width: ${viewport.tablet.sm}) {
            .hero--default .text-xl {
              font-size: ${font.size.lg[1]};
              line-height: ${lineHeight[10]};
                margin-bottom: 20px;
                margin-top: 24px;
            }
            .hero--default .trustpilot-widget-micro {
                position: relative;
                top: 0px;
            }
          }`
            : ``}
        `}
      </style>
    </section>
  );
};

export default Hero;
